import { render, staticRenderFns } from "./NavbarStandard.vue?vue&type=template&id=31aef364&"
import script from "./NavbarStandard.vue?vue&type=script&lang=js&"
export * from "./NavbarStandard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports